<!--<div class="airport-slider-el-container" [class.active]="isActive">
  <div class="airport-slider-el-icon"></div>
  <div class="airport-slider-el-texts">
    <div class="airport-slider-el-title"> -->
<!--      <app-texts-->
<!--        [texts]="[-->
<!--          {text: [el.airportNameRu, el.airportNameEn]}-->
<!--        ]"-->
<!--      />-->
   <!--   {{el.name}} -->
   <!-- </div> -->
  <!--  <div class="airport-slider-el-subtitle"> -->
<!--      <app-texts-->
<!--        [texts]="[-->
<!--          {text: [el.countryNameRu, el.countryNameEn]}-->
<!--        ]"-->
<!--      />-->
   <!--   {{el.city_code}} • {{el.countryObject?.name}} -->
    <!-- </div> -->
  <!-- </div> -->
<!--</div> -->

<div
  class="airport-slider-el-container"
  [class.active]="isActive"
  [class.error]="hasError">

  <button
    class="airport-slider-el-delete"
    *ngIf="canDelete"
    type="button"
    (click)="deleteAirport.emit($event)"
  >
    +
  </button>

  <div class="airport-slider-el-icon">
    <img
      *ngIf="airportService.getCountryCode(el)"
      [src]="airportService.getAirportFlagUrl(el)"
      [alt]="getAirportFlagAlt()"
    />
  </div>

  <div class="airport-slider-el-texts">
    <div class="airport-slider-el-title" #titleRef>
      {{ getAirportName() }}
    </div>

    <div class="airport-slider-el-subtitle">
  <span class="airport-slider-el-subtitle-text">
    {{ getAirportSubtitle() }}
  </span>
      <div class="airport-slider-el-role" *ngIf="el.routeRole">
        {{ getRouteRoleTitle() }}
      </div>

      <span
        class="airport-slider-el-error"
        *ngIf="hasError">
    {{ languageService.translate(['Required', 'Заполнить']) }}
  </span>
    </div>
  </div>

  <div class="airport-slider-el-preview" *ngIf="isTitleOverflow">
    <div class="preview-title">{{ getAirportName() }}</div>
    <div class="preview-subtitle">
      {{ getAirportSubtitle() }}
    </div>
  </div>
</div>
